module.exports = __webpack_public_path__ + "Roboto-Thin.woff";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Thin.woff
// module id = 101
// module chunks = 0